import { useState } from "react";
import { useInfiniteQuery } from "react-query";
import { getEvents } from "services/event.service";
import { PaginationParams } from "types/general.interface";

export default function useEvents(eventQuery?: PaginationParams) {
  const [refreshing, setRefreshing] = useState(false);
  const LIMIT = 20;

  const fetchRecords = async ({ pageParam = 1 }) => {
    const query: PaginationParams = {
      ...eventQuery,
      page: pageParam,
      limit: LIMIT,
    };
    const response = await getEvents(query);

    return {
      results: response.data.data,
      totalPages: Math.ceil(response.data.total / LIMIT),
      nextPage: pageParam + 1,
    };
  };

  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(["events"], fetchRecords, {
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.nextPage < lastPage.totalPages) return lastPage.nextPage;
      return undefined;
    },
  });

  const records = data?.pages.map((page) => page.results)?.flat();
  const handleRefresh = async () => {
    setRefreshing(true);
    await refetch();
    setRefreshing(false);
  };
  const handleEndReached = async () => {
    if (hasNextPage) {
      await fetchNextPage();
    }
  };

  return {
    data: records,
    isLoading,
    isFetchingNextPage,
    refreshing,
    handleRefresh,
    handleEndReached,
    refetch,
  };
}
